"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NCIHeader = NCIHeader;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function NCIHeader(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'p-4' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$imageClassName = _ref.imageClassName,
      imageClassName = _ref$imageClassName === void 0 ? '' : _ref$imageClassName,
      _ref$imageStyle = _ref.imageStyle,
      imageStyle = _ref$imageStyle === void 0 ? {
    maxWidth: '80%'
  } : _ref$imageStyle,
      _ref$imageProps = _ref.imageProps,
      imageProps = _ref$imageProps === void 0 ? {} : _ref$imageProps,
      _ref$imageSource = _ref.imageSource,
      imageSource = _ref$imageSource === void 0 ? '' : _ref$imageSource,
      _ref$url = _ref.url,
      url = _ref$url === void 0 ? '' : _ref$url;
  return /*#__PURE__*/_react.default.createElement("header", {
    className: className,
    style: style
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", _extends({
    src: imageSource,
    style: imageStyle,
    className: imageClassName,
    height: "80",
    alt: "Header Logo"
  }, imageProps))));
}